<template lang="pug">
.contact
  div(v-if="$i18n.locale === 'en'")
    ContactUSEn
  div(v-else)
    ContactUSZh
  Separator(class="my-4")
  span {{$t('last-revision')}} 07/08/2025
</template>

<script setup>
import { Separator } from '@/components/ui/separator'
import ContactUSZh from '~/components/dif-lang/ContactUSZh'
import ContactUSEn from '~/components/dif-lang/ContactUSEn'
</script>

<style lang="postcss">
.contact {
  text-align: left;
  max-width: var(--secondary-max-width);
  padding: 0 1rem 3rem;
  width: 100%;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  h1,
  h2,
  h3 {
    line-height: 1.25;
    margin-top: 3rem;
    font-weight: 500;
  }

  h1 {
    font-size: 2.5rem;
    font-weight: 600;
  }

  summary {
    display: list-item;
  }

  color: var(--secondary-color);
  font-size: 1rem;
  line-height: 2;

  ul {
    padding-left: 1.5rem;
  }

  .email-notice {
    font-size: 0.9rem;
    color: var(--el-text-color-secondary);
    font-style: italic;
    margin-top: 0.5rem;
  }
}
</style>
